/** @format */

import React from 'react'

type Props = {
  /* number between 0 to 100, smaller or larger values are clamped */
  value: number
}

export function Progress(props: Props) {
  const {value} = props
  return (
    <div className="overflow-hidden rounded-full bg-gray-100">
      <Fill width={`${clamp(value)}%`} />
    </div>
  )
}

type FillProps = {
  width: `${number}%`
}

function Fill(props: FillProps) {
  const {width} = props
  return <div className="Progress__Fill" style={{width}} />
}

function clamp(value: number): number {
  return Math.max(0, Math.min(100, value))
}
